export default __webpack_public_path__ + "static/media/ico_clinic_gray.751a4fd7.svg";